import { useQuery, useLazyQuery } from "@apollo/client";
import {
  GET_ALL_FACILITY_TYPES,
  GET_ALL_FACILITY_STATUSES,
  GET_ALL_FACILITY_STATUS_REASONS,
  GET_ALL_STORAGE_TANK_TYPES,
  GET_ALL_TREATMENT_PROCESSES,
  GET_ALL_SYSTEM_INDICATOR_TYPES,
  GET_ALL_FACILITY_INDICATOR_TYPES,
} from "../../queries/siteVisitQrys/sectionConditionsQrys";

const useFacilityFilterOptions = () => {
  const {
    data: facilityTypeData,
    loading: facilityTypesLoading,
    error: facilityTypesError,
  } = useQuery(GET_ALL_FACILITY_TYPES, { fetchPolicy: "cache-and-network" });

  const {
    data: statusData,
    loading: statusesLoading,
    error: statusesError,
  } = useQuery(GET_ALL_FACILITY_STATUSES, { fetchPolicy: "cache-and-network" });

  const {
    data: systemIndicatorTypeData,
    loading: systemIndicatorTypesLoading,
    error: systemIndicatorTypesError,
  } = useQuery(GET_ALL_SYSTEM_INDICATOR_TYPES, { fetchPolicy: "cache-and-network" });

  const {
    data: facilityIndicatorTypeData,
    loading: facilityIndicatorTypesLoading,
    error: facilityIndicatorTypesError,
  } = useQuery(GET_ALL_FACILITY_INDICATOR_TYPES, { fetchPolicy: "cache-and-network" });

  const [
    fetchTreatmentProcesses,
    { data: treatmentProcessData, loading: treatmentProcessesLoading, error: treatmentProcessesError },
  ] = useLazyQuery(GET_ALL_TREATMENT_PROCESSES, { fetchPolicy: "cache-and-network" });

  const [
    fetchStorageTankTypes,
    { data: storageTankTypeData, loading: storageTankTypesLoading, error: storageTankTypesError },
  ] = useLazyQuery(GET_ALL_STORAGE_TANK_TYPES, { fetchPolicy: "cache-and-network" });

  const [
    fetchFacilityStatusReasons,
    { data: facilityStatusReasonData, loading: facilityStatusReasonsLoading, error: facilityStatusReasonsError },
  ] = useLazyQuery(GET_ALL_FACILITY_STATUS_REASONS, { fetchPolicy: "cache-and-network" });

  return {
    data: {
      facilityTypes: facilityTypeData?.getAllFacilityTypes ?? [],
      statuses: statusData?.getAllFacilityStatuses ?? [],
      treatmentProcesses: treatmentProcessData?.getAllTreatmentProcesses ?? [],
      storageTankTypes: storageTankTypeData?.getAllStorageTankTypes ?? [],
      facilityStatusReasons: facilityStatusReasonData?.getAllFacilityStatusReasons ?? [],
      systemIndicatorTypes: systemIndicatorTypeData?.getAllSystemIndicatorTypes ?? [],
      facilityIndicatorTypes: facilityIndicatorTypeData?.getAllFacilityIndicatorTypes ?? [],
    },
    loading: {
      facilityTypes: facilityTypesLoading,
      statuses: statusesLoading,
      treatmentProcesses: treatmentProcessesLoading,
      storageTankTypes: storageTankTypesLoading,
      facilityStatusReasons: facilityStatusReasonsLoading,
      systemIndicatorTypes: systemIndicatorTypesLoading,
      facilityIndicatorTypes: facilityIndicatorTypesLoading,
    },
    errors: {
      facilityTypes: facilityTypesError,
      statuses: statusesError,
      treatmentProcesses: treatmentProcessesError,
      storageTankTypes: storageTankTypesError,
      facilityStatusReasons: facilityStatusReasonsError,
      systemIndicatorTypes: systemIndicatorTypesError,
      facilityIndicatorTypes: facilityIndicatorTypesError,
    },
    fetchTreatmentProcesses,
    fetchStorageTankTypes,
    fetchFacilityStatusReasons,
  };
};

export default useFacilityFilterOptions;
